import { toast, ToastContent, ToastOptions } from "react-toastify";

import ToastErrorIcon from "assets/icons/ToastErrorIcon";
import ToastSuccessIcon from "assets/icons/ToastSuccessIcon";
import ToastWarningIcon from "assets/icons/ToastWarningIcon";

export const helperToast = {
  success: (content: ToastContent, opts?: ToastOptions) => {
    toast.dismiss();
    toast.success(content, {
      icon: ToastSuccessIcon,
      ...opts,
    });
  },
  error: (content: ToastContent, opts?: ToastOptions) => {
    toast.dismiss();
    toast.error(content, {
      icon: ToastErrorIcon,
      ...opts,
    });
  },
  warning: (content: ToastContent, opts?: ToastOptions) => {
    toast.dismiss();
    toast.warning(content, {
      icon: ToastWarningIcon,
      ...opts,
    });
  },
  info: (content: ToastContent, opts?: ToastOptions) => {
    toast.dismiss();
    toast(content, opts);
  },
};
